import React from "react";

const TopButton = () => {

  const scrollToTop = () => window.scrollTo(0, 0);

  return <div onClick={scrollToTop} className="top-button" />
}

export default TopButton